import { Locale, PurchaseOrderLine } from "@shared/types";
import { formatWeightWithLocale } from "./localeUtils";

// Helper function to format product title like OrderLineItemsCell does
export const formatProductTitle = (item: PurchaseOrderLine, locale: Locale): string => {
  const quantity = Number(item.quantity);
  const unitWeight = item.lineItemWeightInGrams && item.quantity ? Number(item.lineItemWeightInGrams) / Number(item.quantity) : undefined;
  const weightText = unitWeight ? formatWeightWithLocale(unitWeight, locale) : "";
  let title = item.productTitle ?? "";

  // Only process weight if quantity > 1
  if (weightText && unitWeight && quantity > 1) {
    const weightVariations = [
      weightText,
      weightText.toLowerCase(),
      weightText.toUpperCase(),
      weightText.replaceAll(/\s+/g, ""),
      weightText.replaceAll(/\s+/g, "").toLowerCase(),
      weightText.replaceAll(/\s+/g, "").toUpperCase(),
    ];

    // Precompute regexes for all variations to avoid creating RegExp objects in loop
    const weightRegexes = weightVariations.map(
      (variation) => new RegExp(variation.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`), "g")
    );

    for (const regex of weightRegexes) {
      if (regex.test(title)) {
        title = title.replace(regex, "");
        break;
      }
    }

    title = title.trim();
  }

  // Only add unit weight if quantity > 1
  return unitWeight && quantity > 1 ? `${title} ${formatWeightWithLocale(unitWeight, locale)}` : title;
};
